export const SECTION_TITLE = 'Provider presenti';
export const SECTION_SINGLE_TITLE = 'Provider presente';
